export default "__VITE_ASSET__CnzPrnA0__"